import api from '@api'

export function getFieldMappingApi(moduleName, additionalUrlParams = {}) {
  return api.get(`/fieldmapping/user/${moduleName}`, {
    params: {
      ...additionalUrlParams,
    },
  })
}
